import React from 'react';

import { useTrackingStatus } from '../../../features/tracking/components/functional/useTrackingStatus';
import { MenuContentItemLabel } from '../../menu/ContentItems/MenuContentItemLabel';
import { HotspotTab } from '@ael/core-api';

interface TabsListingItemProps {
  tab: HotspotTab;
  onClick: () => void;
  isActive?: boolean;
}

export const TabsListingItem: React.FC<TabsListingItemProps> = ({ tab, onClick, isActive }) => {
  const { evaluationResult } = useTrackingStatus(tab.id);
  return (
    <MenuContentItemLabel
      title={tab.title}
      onClick={onClick}
      isActive={isActive}
      trackingStatus={evaluationResult}
      hideConnectingLines
      noWrap
      outsideMenu
    />
  );
};
